module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/cleaning-desktop-c78b63bfe3663cb0e0ff13cf563150e6.jpg";